<template>
	<div class="mod-config">
		<el-card :style="getCardHeight()">
			<el-row style="margin: -5px 10px 8px 5px;font-size: 15px;font-weight: bolder;">监理会议</el-row>
			<el-form :model="dataForm" :rules="dataRule" ref="dataForm" class="border-form">
				<el-row class="set_border" v-show="showSubject">
					<el-col :span="24">
						<el-form-item label="标的物" prop="subjectNoList" class="item">
							<el-select v-model="dataForm.subjectNoList" placeholder="" class="no-border-input" multiple
								clearable>
								<el-option v-for="(item, index) in subjectList" :key="index" :label="item.displayName"
									:value="item.displayValue">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :class="getContactClass()">
					<el-col :span="24">
						<el-form-item label="会议编号" prop="meetNumber" class="item">
							<el-input v-model="dataForm.meetNumber" placeholder="" class="no-border-input"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label="会议名称" prop="meetName" class="item">
							<el-input v-model="dataForm.meetName" placeholder="" class="no-border-input"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label="工作控制号" prop="workNo" class="item">
							<span class="span_lab">{{ dataForm.workNo }}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label="会议时间" class="item" prop="meetDate">
							<el-date-picker class="no-border-input" v-model="dataForm.meetDate" type="date"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label="会议地点" prop="meetPlace" class="item">
							<el-input v-model="dataForm.meetPlace" class="no-border-input"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label="会议主题" prop="meetTitle" class="item">
							<el-input v-model="dataForm.meetTitle" class="no-border-input"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label="会议主持" prop="hoster" class="item">
							<el-input v-model="dataForm.hoster" class="no-border-input"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label="出席单位" prop="attendingUnits" class="item">
							<el-input v-model="dataForm.attendingUnits" class="no-border-input"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label="参加人员" prop="particapants" class="item">
							<span class="span_lab">固定显示：参加人员：见附录“与会人员签到表”</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label="纪要整理" prop="meetRecorder" class="item">
							<el-input v-model="dataForm.meetRecorder" class="no-border-input"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label="日期" class="item" prop="meetRecordDate">
							<el-date-picker class="no-border-input" v-model="dataForm.meetRecordDate" type="date"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="form-title">
					<span>
						内容
					</span>
				</el-row>
				<el-row class="set_border">
					<draggable v-model="dataForm.meetItemList" @start="onDragStart()" @update="onDragEnd">
						<el-row v-for="(item, index) in dataForm.meetItemList" :key="'item' + index">
							<el-col :span="20" style="margin: 10px 0px 10px 100px;">
								<el-input type="textarea" class="desc_input1" autosize
									v-model="item.itemContext"></el-input>
							</el-col>
							<el-col :span="2">
								<el-button v-preventReClick type="text" size="small"
									@click="delMeetItem(index)">删除</el-button>
							</el-col>
						</el-row>
					</draggable>
					<el-button v-preventReClick class="btn" type="primary" size="small" @click="addMeetItem()"
						style="margin: 5px;">添加内容段落</el-button>
				</el-row>
			</el-form>
			<el-row class="formBtnGroup" style="margin-top: 40px;">
				<div class="set_bg">
					<el-button v-preventReClick class="btn" type="primary" size="small"
						@click="dataFormSubmit()">保存</el-button>
					<el-button v-preventReClick class="rebtn" size="small" plain @click="goBack()">取消</el-button>
				</div>
			</el-row>
		</el-card>
	</div>
</template>

<script>
import $common from "@/utils/common.js"
import draggable from 'vuedraggable';
export default {
	name: "contactdocument-add-or-update",
	data() {
		return {
			visible: false,
			inline: false,
			showSubject: false,
			dataForm: {
				workNo: $common.getItem("workNo"),
				subjectNoList: [],
				executedFileType: '2',
				meetId: '',
				meetNumber: '',
				projectName: '',
				meetTitle: '',
				meetDate: '',
				meetPlace: '',
				particapants: '',
				meetRecorder: '',
				meetRecordDate: '',
				meetName: '',
				hoster: '',
				attendingUnits: '',
				meetItemList: []
			},
			subjectList: [],
			dataRule: {
				subjectNoList: [
					{ required: true, message: " ", trigger: "blur" }
				],
			},
		}
	},
	components: {
		draggable,
	},
	mounted() {
		this.dataForm.meetId = this.$route.query.meetId
		this.dataForm.subjectNo = this.$route.query.subjectNo
		this.init()
	},
	methods: {
		getCardHeight() {
			var height = this.$store.state.common.documentClientHeight - 75;
			return { minHeight: height + 'px' }
		},
		getCurrentTime() {
			//获取当前时间并打印
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
			return yy + '-' + mm + '-' + dd;
		},
		init() {
			this.dataForm = {
				workNo: $common.getItem("workNo"),
				subjectNoList: [],
				meetId: this.$route.query.meetId,
				subjectNo: this.$route.query.subjectNo,
				executedFileType: '2',
				meetNumber: '',
				projectName: '',
				meetTitle: '',
				meetDate: '',
				meetPlace: '',
				particapants: '',
				meetRecorder: '',
				meetRecordDate: '',
				meetName: '',
				hoster: '',
				attendingUnits: '',
				meetItemList: []
			};
			// 先获取标的物列表，再处理其他逻辑
			this.getSubjectDropDown().then(() => {
				if (this.dataForm.meetId) {
					this.$http({
						url: this.$store.state.httpUrl + `/business/meetinfo/info/${this.dataForm.meetId}`,
						method: 'get',
						params: {}
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.dataForm = data.body;
						}
					})
				} else {
					this.getInitMeet();
				}

				this.$nextTick(() => {
					this.visible = true;
					if (this.$refs["dataForm"] !== undefined) {
						this.$refs["dataForm"].resetFields();
					}

					// 设置默认选中的标的物
					if (this.dataForm.subjectNo) {
						let subjectNoList = []
						subjectNoList.push(this.dataForm.subjectNo)
						this.$set(this.dataForm, 'subjectNoList', subjectNoList)
					} else if (this.subjectList && this.subjectList.length > 0) {
						// 如果没有传入subjectNo，则默认选中第一个
						let subjectNoList = []
						subjectNoList.push(this.subjectList[0].displayValue)
						this.$set(this.dataForm, 'subjectNoList', subjectNoList)
					}
				});
			});
		},
		getSubjectDropDown() {
			return this.$http({
				url: this.$store.state.httpUrl + "/common/getSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.subjectList = data.body;
					if (this.subjectList != undefined && this.subjectList.length > 1) {
						this.showSubject = true
					} else {
						this.showSubject = false
					}
					return data.body;
				}
			});
		},
		getInitMeet() {
			this.$http({
				url: this.$store.state.httpUrl + `/business/meetinfo/initMeet`,
				method: "GET",
				params: this.$http.adornParams({
					workNo: $common.getItem("workNo"),
					executedFileType: '2',
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$set(this.dataForm, "projectName", data.body.projectName);
					this.$set(this.dataForm, "meetNumber", data.body.meetNumber);
					// this.$set(this.dataForm, "meetDate", this.getCurrentTime());
					this.$set(this.dataForm, "meetRecordDate", this.getCurrentTime());
					this.$set(this.dataForm, "executedFileType", '2');
				}
			});
		},
		addMeetItem() {
			let meetItem = {
				itemContext: '',
			}
			this.dataForm.meetItemList.push(meetItem);
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		//表单提交
		dataFormSubmit() {
			this.dataForm.workNo = $common.getItem("workNo")
			this.dataForm.executedFileType = '2'
			this.$refs["dataForm"].validate(valid => {
				if (valid) {
					let _url = "/business/meetinfo/save";
					if (this.dataForm.meetId && this.dataForm.meetId != 0) {
						_url = "/business/meetinfo/update";
					}
					this.$http({
						url: this.$store.state.httpUrl + _url,
						method: "post",
						data: this.$http.adornData(this.dataForm)
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.$router.push({ name: 'hqmeetingList' });
								}
							});
						}
					});
				}
			});
		},
		goBack() {
			this.$router.back()
		},
		delMeetItem(index) {
			this.dataForm.meetItemList.splice(index, 1)
		},
		getContactClass() {
			if (this.showSubject) {
				return 'set_border'
			} else {
				return 'set_border_second'
			}
		},
		onDragStart(index, index1) {
		},
		onDragEnd(event) {
			event.preventDefault();
		},
	}
}
</script>
<style scoped lang="scss">
.selItemInput.descAreaLg {
	width: 640px !important;
}

.detail_input ::v-deep .el-input__inner {
	width: 560px !important;
}

.item_input ::v-deep .el-input__inner {
	width: 600px !important;
}

.photo_input ::v-deep .el-input__inner {
	width: 437px !important;
}

.file_input ::v-deep .el-input__inner {
	width: 100% !important;
}

.prob_btn {
	margin-left: -40px;
	position: absolute;
}

.upload-demo ::v-deep .el-upload-dragger {
	width: 300px;
	height: 100px;
	margin-left: 20px;
}

.upload-demo ::v-deep .el-upload-dragger .el-icon-upload {
	font-size: 40px;
	margin-top: 15px;
	line-height: 26px;
}

.upload-demo ::v-deep .el-upload-dragger .el-upload__text {
	line-height: 8px;
}

::v-deep .el-tabs__item.is-active {
	color: #1d1d86;
	background-color: #E1F1FF;
}

::v-deep .el-tabs__item:hover {
	color: #121213;
	background-color: #eceeed;
}

::v-deep .el-tabs--top .el-tabs__item.is-top {
	width: 134.5px;
	text-align: center;
}

.border {
	border: 1px solid #cbcbd3;
	height: 290px;
	width: 590px
}

::v-deep .el-input__inner {
	border: solid #dadada 1px;
}

.border-form .el-row.set_border {
	border-bottom: solid #dadada 1px;
	border-left: solid #dadada 1px;
	border-right: solid #dadada 1px;
}

.border-form .el-row.set_border_second {
	border-bottom: solid #dadada 1px;
	border-left: solid #dadada 1px;
	border-right: solid #dadada 1px;
	border-top: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
	border-top: solid #dadada 1px;
}

::v-deep .el-form-item {
	/* display: flex !important; */
	align-items: stretch !important;
	margin-bottom: 0px !important;
}

.item {
	display: flex !important;
	align-items: stretch !important;
}

.item::v-deep .el-form-item__content {
	display: flex !important;
	align-items: stretch !important;
	width: 100% !important;
}

.item::v-deep .el-form-item__label {
	color: #00428E !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border-right: solid #dadada 1px;
	display: flex !important;
	align-items: flex-start !important;
	padding: 10px 12px 0 12px !important;
	margin: 0 !important;
	height: auto !important;
	line-height: 1.5 !important;
	width: 115px !important;
	/* 保持原有宽度 */
	box-sizing: border-box !important;
}

/* 确保 textarea 容器也拉伸 */
.item::v-deep .el-textarea {
	display: flex !important;
	align-items: stretch !important;
	height: 100% !important;
}

.item::v-deep .el-textarea__inner {
	border: none !important;
	resize: vertical !important;
	min-height: 80px !important;
	height: 100% !important;
}

.setcontact_item ::v-deep .el-form-item__label {
	margin-left: 2px !important;
	width: 93px !important;
	margin-bottom: 10px;
	background-color: #E1F1FF;
	color: #00428E !important;
	font-weight: bold !important;
}

.setsummary_item ::v-deep .el-form-item__label {
	margin-left: 2px !important;
	width: 93px !important;
	margin-bottom: 15px;
	background-color: #E1F1FF;
	color: #00428E !important;
	font-weight: bold !important;
}

.no-border-input.el-date-editor.el-date-editor--date {
	::v-deep .el-input__suffix {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
		position: absolute !important;
		/* 必须加！否则right无效且图标易消失 */
		top: 50% !important;
		/* 垂直居中，避免图标偏移 */
		transform: translateY(-50%) !important;
		right: 5px !important;
		/* 你要的右侧5px间距 */
		width: auto !important;
		/* 取消固定宽度，避免容器遮挡 */
		height: 100% !important;
		/* 占满高度，确保点击生效 */
		pointer-events: auto !important;
		/* 保证图标可点击，避免失效 */
		z-index: 1 !important;
		/* 防止图标被遮挡 */
	}

	/* 隐藏左侧占位，不影响右侧图标 */
	::v-deep .el-input__prefix {
		display: none !important;
		width: 0 !important;
		padding: 0 !important;
		margin: 0 !important;
	}

	/* 补充：给输入框右侧留空间，避免文字遮挡图标 */
	::v-deep .el-input__inner {
		padding-right: 30px !important;
		/* 适配5px右侧间距，留出图标空间 */
		padding-left: 15px !important;
		/* 重置左侧内边距，消除空白 */
		border-radius: 0 !important;
		// border: 1px solid #dadada !important;
	}
}

.no-border-input ::v-deep .el-input__inner {
	border: none !important;
}

.no-border-input ::v-deep .el-textarea__inner {
	border: none !important;
}

.form-title {
	background-color: #E1F1FF;
	color: #00428E;
	font-weight: bold !important;
	padding: 10px;
	border: solid #dadada 1px;
	border-top: 0px;
}

.set_data {
	margin-top: 1px;
}

.photo_row {
	// border: 1px solid rgba(235, 238, 240, 1);
	width: 80%;
	padding-bottom: 20px;
	padding-top: 20px;
	margin-top: 10px
}

.photo_col {
	border: 1px solid rgba(235, 238, 240, 1);
}

.photo-delete-btn {
	position: absolute;
	top: -25px;
	/* 负值让按钮完全在容器顶部外面 */
	right: 0;
	width: 24px;
	height: 24px;
	background-color: #ffffff;
	color: #333333;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 10;
	transition: all 0.3s ease;
	font-size: 14px;
}

.photo-delete-btn:hover {
	color: black;
	transform: scale(1.1);
}

/* 或者想要更明显一点的样式 */
.photo-delete-btn-prominent {
	position: absolute;
	top: -30px;
	/* 更靠上 */
	right: -5px;
	/* 稍微偏右 */
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background-color: #f0f0f0;
	color: #666666;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 10;
	transition: all 0.3s ease;
	border: 1px solid #cccccc;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
	font-size: 16px;
	font-weight: bold;
}

/* 确保照片区域有足够的上边距 */
.photo_col div[style*="margin:20px"] {
	padding-top: 10px;
	/* 给按钮留出空间 */
}

.no-border-input {
	width: 90% !important;

	&.el-select,
	&.el-date-editor.el-date-editor--date {
		width: 90% !important;
	}
}

.set_bg {
	padding-top: 10px;
	width: 65%;
	height: 50px;
	bottom: 6px;
	position: fixed;
	left: 25%;
	background-color: #f7f1f1;
}

::v-deep .desc_input1 .el-textarea__inner {
	// padding-right: 50px !important;
	border: 0px;
	border-bottom: 1px solid #dadada;
	// color: black;
	//  resize: none;
}

.span_lab {
	color: #606266;
	margin-left: 14px;
	font-size: 13px;
}
</style>
